// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyDbk_HVqopTWG9pMIJWJsQ6kunUJ8GFJ8o",
    authDomain: "meal-planner-a4500.firebaseapp.com",
    projectId: "meal-planner-a4500",
    storageBucket: "meal-planner-a4500.appspot.com",
    messagingSenderId: "652462822288",
    appId: "1:652462822288:web:875e98dba2e5530825d915"
}


// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);


export default app;